export default __webpack_public_path__ + "static/media/emotional-balance-tree.fe7ea2ce.svg";